import axios from "@utils/axios-instance";
import { TBasePage, TLandingPage, TPagePayload, TPageStats } from "@/models/landing-pages.model";

export const generateLPService = async (data: TPagePayload): Promise<TLandingPage> => {
  const response = await axios.post("/landingpage", data);
  return response.data;
};

export const getLandingPagesService = async (): Promise<TLandingPage[]> => {
  const response = await axios.get("/landingpage");
  return response.data;
};

export const updateLandingPageService = async (data: Partial<TLandingPage> & { id: number }): Promise<TLandingPage> => {
  const { id, ...page } = data;
  const {
    name,
    title,
    subheading,
    content,
    callToAction,
    video,
    image,
    color,
    industry,
    imageOpacity,
    questionnaireId,
    html,
    css,
    components,
    googleAnalyticId,
    headerTrackingCode,
    SEOPageTitle,
    SEOPageDescription,
  } = page;

  const response = await axios.patch(`/landingpage/${id}`, {
    name,
    title,
    subheading,
    content,
    callToAction,
    video,
    image,
    color,
    industry,
    imageOpacity,
    questionnaireId: questionnaireId ? Number(questionnaireId) : undefined,
    html,
    css,
    components,
    googleAnalyticId,
    headerTrackingCode,
    SEOPageTitle,
    SEOPageDescription,
  });
  return response.data;
};

export const publishLandingPageService = async (pageId: number): Promise<void> => {
  await axios.patch(`/landingpage/publish/${pageId}`, { publish: true });
};

export const unpublishLandingPageService = async (pageId: number): Promise<void> => {
  await axios.patch(`/landingpage/publish/${pageId}`, { publish: false });
};

export const createThankyouPage = async (): Promise<TBasePage> => {
  const response = await axios.post("/thankyoupage");
  return response.data;
};

export const duplicatePageService = async (pageId: number): Promise<TLandingPage> => {
  const response = await axios.post(`/page/duplicate/${pageId}`);
  return response.data;
};

export const deleteLandingPageService = async (pageId: number): Promise<void> => {
  await axios.delete(`/landingpage/${pageId}`);
};

export const getPageById = async (pageId: number): Promise<TLandingPage> => {
  const response = await axios.get(`/landingpage/${pageId}`);
  return response.data;
};

export const getPageStats = async (pageId: number): Promise<TPageStats> => {
  const response = await axios.get(`/landingpage/${pageId}/stats`);
  return response.data;
};

export const createCopyControlVariation = async (pageId: number): Promise<TLandingPage> => {
  const response = await axios.post(`/page/copy-control-variation/${pageId}`);
  return response.data;
};

export default {
  createThankyouPage,
  duplicatePageService,
  deleteLandingPageService,
  generateLPService,
  getLandingPagesService,
  updateLandingPageService,
  publishLandingPageService,
  unpublishLandingPageService,
};
